/* eslint-disable react-hooks/rules-of-hooks */

const BACKEND_URL = "https://api.cleankitchen.ee/v1";

export const getDeliveryDates = async (zipCode?: string, startDate: string = null, endDate: string = null): Promise<Response> => {
  const url = new URL(`${BACKEND_URL}/delivery-dates`);
  const params: Record<string, string> = { startDate, endDate, zipCode };
  Object.keys(params).forEach(param => {
    if (params[param]) url.searchParams.append(param, params[param]);
  });

  return await fetch(url.toString(), {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
    },
  });
};

interface Feature {
  name: string;
  enabled: boolean;
}

export const getFeatures = async (name?: string): Promise<Feature[]> => {
  const id = CUSTOMER?.id;
  const hmac = CUSTOMER?.hmac;
  const response = await fetch(
    `${BACKEND_URL}/features?${name ? "name=" + name : ""}`,
    {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "content-type": "application/json",
        CustomerId: id.toString(),
        "X-Signature": hmac,
      },
    }
  );
  if (response.ok) {
    return response.json();
  }
};
